module.exports = __webpack_public_path__ + "static/media/loader.54318624.gif";